/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React base styles
import colors from "../../../../../assets/theme/base/colors";

const { gradients, dark } = colors;

function configs(labels, datasets) {
  const backgroundColors = [];

  if (datasets.backgroundColors) {
    datasets.backgroundColors.forEach((color) =>
      gradients[color]
        ? backgroundColors.push(gradients[color].state)
        : backgroundColors.push(dark.main),
    );
  } else {
    backgroundColors.push(dark.main);
  }

  return {
    data: {
      labels,
      datasets: [
        {
          label: datasets.label,
          weight: 9,
          // Percentage, not px — the chart now renders in a fixed 160px box,
          // where the old cutout: 94 (px) exceeded the radius and erased the ring.
          cutout: "68%",
          tension: 1,
          pointRadius: 2,
          borderWidth: 4,
          backgroundColor: backgroundColors,
          borderColor: backgroundColors,
          data: datasets.data,
          // Extra arrays carried on the dataset so the tooltip callback
          // below can read the player's actual points and formatted
          // amount per slice, even though `data` itself uses floored
          // display weights (so tiny slices stay visible in the ring).
          actualPoints: datasets.actualPoints,
          amounts: datasets.amounts,
          fill: false,
        },
      ],
    },

    options: {
      responsive: true,
      backgroundColors,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: true,
          // Extra right padding inside the tooltip — gives the label text
          // 20px of breathing room before the tooltip's right edge. Other
          // sides keep Chart.js defaults.
          padding: { top: 6, right: 20, bottom: 6, left: 6 },
          // Tooltip: just the metric name (title) and "{name}: {pts}" on
          // the body line. Pulls the real player points from the dataset's
          // `actualPoints` array so the value never reflects the floored
          // slice weight used to keep small KPIs visible in the ring.
          //
          // High z-index keeps the tooltip above the center "total points"
          // overlay; see also the wrapper styles in ReportsDoughnutChart.
          //
          // The leading spaces in the label create a visual gap between the
          // color swatch and the metric name. Chart.js < v3.5 doesn't
          // support `boxPadding`, so this is the most reliable way to add
          // that gap on this codebase's pinned version (3.4.1).
          callbacks: {
            label: (context) => {
              const ds = context.dataset || {};
              const idx = context.dataIndex;
              const pts = Array.isArray(ds.actualPoints) ? ds.actualPoints[idx] : context.parsed;
              // Round to whole number — no decimal places in the tooltip.
              const rounded = Math.round(Number(pts) || 0);
              const name = context.label || ds.label || "";
              return `    ${name}: ${rounded} pts`;
            },
          },
        },
      },
      interaction: {
        intersect: false,
        mode: "index",
      },
      scales: {
        y: {
          grid: {
            drawBorder: false,
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            display: false,
          },
        },
        x: {
          grid: {
            drawBorder: false,
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            display: false,
          },
        },
      },
    },
  };
}

export default configs;
